import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';

import { ReviewsService } from 'src/app/e-commerce/common/reviews/reviews.service';

@Component({
  selector: 'app-pending-reviews',
  templateUrl: './pending-reviews.component.html',
  styleUrls: ['./pending-reviews.component.css']
})
export class PendingReviewsComponent implements OnInit {
  displayColumns: string[] = ["coustomer", "entityName", "title","comment","status","Actions" ]//"createdOn","rating",
  dataSource = new MatTableDataSource<any>([])
  isLoading:boolean=false
  index: number = 0;
  size: number = 10;
  dataLength :number =0 ;
  data:any ={}; 
  constructor( private httpClient: HttpClient,private reviewsService: ReviewsService, private snotifyService: ToastrService,) { }
 
  ngOnInit() {
    this.getPendingReviewItem();
  }





  changeStatus(id,status){
    this.reviewsService.changeStatusReview(id,status).subscribe((res)=>{
      this.getPendingReviewItem()
      this.openNotifySuccess("The status has been changed")
    },err=>{
      this.openNotifyError('Somthing went wrong')
    })
  }



  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifySuccess(message: any) {
    this.snotifyService.success(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  getPendingReviewItem(){
    this.data ={
      pagination: {  start: this.index, number: this.size },
      search: {
        predicateObject: {
          Status: 1,
          EntityType:1
        }
      },
      sort: { }
    } 
    this.httpClient.post(`/ReviewApi/Grid`,this.data).subscribe( (res:any)=>{
     this.dataSource=res.data; 
     this.dataLength = res.totalCount;
     this.isLoading=true;
    })
    err=>{
      this.isLoading=true;
      console.log(err.message)
    }
  }
  changePage(event) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getPendingReviewItem()
  }


}
